import { Gauge, Layers, Lock, ShieldCheck, Wrench } from "lucide-react";

// Shared spec data for the Hard Lids (Tour Top Cover) category page and every
// vehicle detail page, so neither page needs to import the other's module.
export const SPECS = [
  { label: "Weight", value: "41kg", sub: "(90 lbs)", icon: Gauge },
  { label: "Load Rating", value: "250kg", sub: "(550 lbs) dynamic", icon: ShieldCheck },
  { label: "Mounting Tracks", value: "17 + 4", sub: "T-slots on top, 4 below", icon: Layers },
  { label: "Material", value: "6063 T6 Aluminium", sub: "3CR12 stainless brackets", icon: Layers },
  { label: "Security", value: "2x Keyed Locks", sub: "Push-lock, weatherproof seal", icon: Lock },
  { label: "Install Time", value: "~60 Minutes", sub: "No drilling required", icon: Wrench },
];
